import { getHeaders } from '@repo/utils';
import { Configuration, CoworkerApi } from '@sp-saljapro/coworker/generated';
import { useQuery } from '@tanstack/react-query';

import { API } from './utils.api';

export const useCoworkerPermissions = (basePath: string, buCode: string, enabled = true) => {
    return useQuery({
        queryKey: [API.coworkerPermissions, buCode, basePath],
        queryFn: async () => {
            const headers = await getHeaders();
            const api = new CoworkerApi(
                new Configuration({
                    basePath,
                    headers: Object.fromEntries(headers.entries()),
                })
            );
            return api.coworkerIamControllerGetCoworkerPermissions({ x_bucode: buCode });
        },
        enabled: Boolean(buCode) && enabled,
    });
};
